import React from 'react';
import PropTypes from 'prop-types';
import LiteralCurrency from 'components/LiteralCurrency';
import { GirdedQuestionIcon } from 'refactored/ui/icons';

const TotalPrice = ({
  totalPrice,
  toggleDropdown,
  t,
  collapsable,
  moreThanOneDayQuote,
  priceTitle,
}) => (
  <div
    className={`price-container ${collapsable ? 'collapsable' : ''} ${
      moreThanOneDayQuote ? 'more-than-one-day-quote' : ''
    }`}
  >
    <div
      className={`price-literal-container ${collapsable ? 'collapsable' : ''}`}
    >
      <div className={`price-literal ${collapsable ? 'collapsable' : ''}`}>
        {moreThanOneDayQuote ? t('from') : ''}{' '}
        <LiteralCurrency value={totalPrice} />
      </div>

      {collapsable && <GirdedQuestionIcon onClick={toggleDropdown} />}
    </div>
    <div className="vat-literal">{priceTitle}</div>
  </div>
);

TotalPrice.propTypes = {
  t: PropTypes.func.isRequired,
  totalPrice: PropTypes.number,
  priceConcepts: PropTypes.arrayOf(
    PropTypes.shape({
      concept: PropTypes.string.isRequired,
      tooltipInnerComponent: PropTypes.func,
      conceptQuantity: PropTypes.number.isRequired,
    })
  ),
  collapsable: PropTypes.bool,
  moreThanOneDayQuote: PropTypes.bool,
  priceTitle: PropTypes.string,
  toggleDropdown: PropTypes.func.isRequired,
};

TotalPrice.defaultProps = {
  totalPrice: 0,
  priceConcepts: [],
  collapsable: true,
  moreThanOneDayQuote: false,
  priceTitle: '',
};

export default TotalPrice;
